export default __webpack_public_path__ + "static/exhibit-c-1-a4da6dce3ba3d6b39b33bf58cb35b0ab.png";